module.exports = __webpack_public_path__ + "img/widget_documents.8685828.png";